import { render, staticRenderFns } from "./SetOptionTable.vue?vue&type=template&id=5d39a40c&scoped=true&"
import script from "./SetOptionTable.vue?vue&type=script&lang=ts&"
export * from "./SetOptionTable.vue?vue&type=script&lang=ts&"
import style0 from "./SetOptionTable.vue?vue&type=style&index=0&id=5d39a40c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d39a40c",
  null
  
)

export default component.exports